import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function FloatingSupport() {
  const navigate = useNavigate();
  
  return (
    <motion.button
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-50 w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/30 hover:shadow-xl hover:shadow-teal-500/40 transition-shadow flex items-center justify-center"
      style={{ borderRadius: '50%' }}
      onClick={() => navigate('/support')}
      data-testid="floating-support-btn"
    >
      <MessageCircle size={24} />
    </motion.button>
  );
}
